import { useState } from 'react';
import { Link } from 'react-router-dom';
import { publicApi } from '../lib/api';
import { Field } from '../components/ui';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  async function submit(e) {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      await publicApi.post('/users/forgot-password', { email });
      // The API intentionally returns the same answer for known and unknown
      // addresses, so the UI must not reveal whether an account exists.
      setSent(true);
    } catch (err) {
      setError(err.message || 'Unable to send reset instructions');
    } finally { setBusy(false); }
  }

  return (
    <main className="login-wrap">
      <img className="logo" src="/logo.png" alt="" />
      <h1>Reset your password</h1>
      {sent ? (
        <>
          <p className="note ok">If an active account uses that email, reset instructions are on the way.</p>
          <Link className="btn pri" to="/login">Back to sign in</Link>
        </>
      ) : (
        <>
          <p className="sb">Enter your work email and we’ll send a secure reset link.</p>
          <form className="col" style={{ gap: 'var(--s-3)' }} onSubmit={submit}>
            <Field label="Email" id="forgot-email" error={error}>
              <input id="forgot-email" className="fi" type="email" autoComplete="email" required
                value={email} onChange={e => setEmail(e.target.value)} />
            </Field>
            <button className="btn pri" type="submit" disabled={busy}>
              {busy ? 'Sending…' : 'Send reset link'}
            </button>
            <Link className="sb" to="/login" style={{ textAlign: 'center' }}>Back to sign in</Link>
          </form>
        </>
      )}
    </main>
  );
}
